import {Translate} from 'react-redux-i18n';
import {MenuItem, TextField} from '@material-ui/core';
import {Icon} from 'front-onceforall-core';
import authenticationService from '../../../../services/authentication/AuthenticationService';
import {MANAGER_ROLE, INVITING_ROLE, EXPLORER_ROLE, CONSULTANT_ROLE, MANAGE_PROJECT_PERMISSION, SIGN_PERMISSION} from '../../../../utils/constant';
import config from '../../../../../config';

function AdminActionsView() {
  const isBackOffice = authenticationService.roles().isBackOffice();
  const currentOrganisationRole = localStorage.getItem('backOfficeRole') ? localStorage.getItem(
    'backOfficeRole'
  ) : MANAGER_ROLE;

  function handleBackOfficeChangeRole(event) {
    localStorage.setItem('backOfficeRole', event.target.value);
    document.location.reload();
  }

  function handleSwitchCanSignPermission() {
    localStorage.setItem(`offlineMode_hasPermission${SIGN_PERMISSION}`, !authenticationService.roles().hasPermission(SIGN_PERMISSION));
    document.location.reload();
  }

  function handleSwitchCanManageProject() {
    localStorage.setItem(
      `offlineMode_hasPermission${MANAGE_PROJECT_PERMISSION}`,
      !authenticationService.roles().hasPermission(MANAGE_PROJECT_PERMISSION)
    );
    document.location.reload();
  }

  function handleSwitchIsBackOffice() {
    localStorage.setItem('offlineMode_isBackOffice', !authenticationService.roles().isBackOffice());
    document.location.reload();
  }

  return (
    <>
      {(config.offline || isBackOffice) &&
        <div className="my-2 mx-4 background-bo">
          <TextField
            select
            value={currentOrganisationRole}
            onChange={handleBackOfficeChangeRole}
            variant="standard"
          >
            <MenuItem value={MANAGER_ROLE}><Translate value="user.roles.MANAGER"/></MenuItem>
            <MenuItem value={INVITING_ROLE}><Translate value="user.roles.INVITING"/></MenuItem>
            <MenuItem value={CONSULTANT_ROLE}><Translate value="user.roles.CONSULTANT"/></MenuItem>
            <MenuItem value={EXPLORER_ROLE}><Translate value="user.roles.EXPLORER"/></MenuItem>
          </TextField>
        </div>
      }
      {config.offline &&
        <button
          type="button"
          className="button-square background-bo"
          onClick={handleSwitchCanSignPermission}
          tooltip={authenticationService.roles().hasPermission(
            SIGN_PERMISSION
          ) ? 'Currently can sign' : 'Currently can NOT sign'}
          flow="bottom"
        >
          <span
            className={authenticationService.roles().hasPermission(SIGN_PERMISSION) ? 'success' : 'active'}
          >
            <Icon icon={authenticationService.roles().hasPermission(SIGN_PERMISSION) ? 'check' : 'cross'}/>
          </span>
        </button>
      }
      {config.offline &&
        <button
          type="button"
          className="button-square background-bo"
          onClick={handleSwitchCanManageProject}
          tooltip={authenticationService.roles().hasPermission(MANAGE_PROJECT_PERMISSION) ? 'Currently can manage project' : 'Currently can NOT manage project'}
          flow="bottom"
        >
          <span
            className={authenticationService.roles().hasPermission(MANAGE_PROJECT_PERMISSION) ? 'success' : 'active'}
          >
            <Icon
              icon={authenticationService.roles().hasPermission(MANAGE_PROJECT_PERMISSION) ? 'check' : 'cross'}
            />
          </span>
        </button>
      }
      {config.offline &&
        <button
          type="button"
          className="button-square background-bo"
          onClick={handleSwitchIsBackOffice}
          tooltip={authenticationService.roles().isBackOffice() ? 'Currently is a back office user' : 'Currently is NOT a back office user'}
          flow="bottom"
        >
          <span className={authenticationService.roles().isBackOffice() ? 'success' : 'active'}>
            <Icon icon={authenticationService.roles().isBackOffice() ? 'check' : 'cross'}/>
          </span>
        </button>
      }
    </>
  );
}

export default AdminActionsView;
